import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert.jsx";
import MyPage from "../../MyPage.js";
import SubTabsDashboard from "../../SubTabsDashboard.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class DashboardHistory extends Component{ 

    constructor(props){
      super(props);

      this.state={
          budgetyearhistory:[],
          modalTitle:"",
          budgetyearhistoryid:0,
          budgetyearid_y_hist:0,
          fyname_y_hist: "",
		      origin_charges_y_hist: "",
		      freight_y_hist: "",
		     destination_charges_y_hist: "",
		     customs_duties_y_hist: "",
		     vat_y_hist: "",
		     warehousing_y_hist: "",
		     kitting_vas_y_hist: "",
		     last_delivery_mile_y_hist: "",
		     return_flow_y_hist: "",
		     additional_fees_y_hist: "",
		     purchases_costs_y_hist: "",
         transferts_costs_y_hist:"",
		     total_budget_y_histarehouse_y_hist: "",
         comment_y_hist:"",
         update_y_hist:"",

          CountryNameFilter:"",
          RegionNameFilter:"",
          WarehouseNameFilter:"",
          FiscalYearFilter:"",
          ProductDescriptionFilter:"",
          BudgetYearHistoryIdFilter:"",
          BudgetYearIdFilter:"",
          CurrentYearFilter:"",
          BudgetYearHistoryCommentFilter:"",
          budgetyearhistoryWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          fiscalYears: [], 
          productdescriptions: [],
          warehouseNames: [],
          loading: true,
          currentYearIndex: 0,
          currentYear: null,
      }
  }

  FilterFn(){
    var RegionNameFilter = this.state.RegionNameFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var BudgetYearHistoryIdFilter = this.state.BudgetYearHistoryIdFilter;
    var BudgetYearIdFilter = this.state.BudgetYearIdFilter;
    var BudgetYearHistoryCommentFilter = this.state.BudgetYearHistoryCommentFilter

    var filteredData=this.state.budgetyearhistoryWithoutFilter.filter(
        function(el){
            return  el.fyname_y_hist.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.budgetyearhistoryid.toString().toLowerCase().includes(
                BudgetYearHistoryIdFilter.toString().trim().toLowerCase()
            )&&  
            el.budgetyearid_y_hist.toString().toLowerCase().includes(
            BudgetYearIdFilter.toString().trim().toLowerCase()
        ) && 
        el.comment_y_hist.toString().toLowerCase().includes(
          BudgetYearHistoryCommentFilter.toString().trim().toLocaleLowerCase()
        )
        }
    );

    this.setState({budgetyearhistory:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.budgetyearhistoryWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({budgetyearhistory:sortedData});

}




changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFn();
  }

changeWarehouseNameFilter = (e)=>{
    this.state.WarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }


changeBudgetYearHistoryIdFilter = (e)=>{
    this.state.BudgetYearHistoryIdFilter=e.target.value;
    this.FilterFn();
  }


  changeBudgetYearIdFilter = (e)=>{
    this.state.BudgetYearIdFilter=e.target.value;
    this.FilterFn();
  }

  changeCurrentYearFilter = (e)=>{
    this.state.CurrentYearFilter=e.target.value;
    this.FilterFn();
  }

  changeBudgetYearHistoryCommentFilter = (e)=>{
    this.state.BudgetYearHistoryCommentFilter=e.target.value;
    this.FilterFn();
  }



refreshList = () => {
    axiosService.get('/budgetyearhistory/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ budgetyearhistory: data, budgetyearhistoryWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

  formatUpdateDate(update_y_hist) {
    if (!update_y_hist) {
      return 'N/A'; // Handle the case where update_y_hist is not available
    }

    const parsedDate = new Date(update_y_hist);
    const formattedDate = parsedDate.toLocaleDateString(); // Adjust the format as needed

    return formattedDate;
  }

componentDidMount(){
  this.refreshList();
  
}



render(){
  const {
      budgetyearhistory,
      modalTitle,
      budgetyearhistoryid,
      budgetyearid_y_hist,
      fyname_y_hist,
		  regionname_y_hist,
		  warehousename_y_hist,
		  origin_charges_y_hist,
		  freight_y_hist,
		 destination_charges_y_hist,
		customs_duties_y_hist,
		vat_y_hist,
		     warehousing_y_hist,
		     kitting_vas_y_hist,
		     last_delivery_mile_y_hist,
		     return_flow_y_hist,
		     additional_fees_y_hist,
		     purchases_costs_y_hist,
         transferts_costs_y_hist,
		     total_budget_y_histarehouse_y_hist,
         comment_y_hist,
         update_y_hist,
      loading,
      fiscalYears,
      currentYearIndex,
      currentYear

  }=this.state;

  //const currentYear = fiscalYears[currentYearIndex];

  
  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsDashboard />
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      value={currentYear}
      placeholder="Filter"/>
      </div>
      Fiscal Year
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Saved Date
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Origin Charges Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Freight Year 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Destination Charges Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Customs Duties Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Vat Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Warehousing Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Kitting & Vas Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Last Delivery Mile Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Return Flow Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Additional Fees Year
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Purchases Costs Year
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Costs Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Total Budget Year 
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeBudgetYearHistoryCommentFilter}
      value={currentYear}
      placeholder="Filter"/>
      </div>
      Comments
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {budgetyearhistory.map(dep=>
      <tr key={dep.budgetyearhistoryid} className="row-hover">
          <td className="table-text">{dep.fyname_y_hist ?? 'N/A'}</td>
          <td className="table-text">{this.formatUpdateDate(dep.update_y_hist) ?? 'N/A'}</td>
          <td className="table-text">{dep.origin_charges_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.origin_charges_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.freight_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.freight_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.destination_charges_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.destination_charges_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.customs_duties_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.customs_duties_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.vat_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.vat_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.warehousing_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.warehousing_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.kitting_vas_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.kitting_vas_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.last_delivery_mile_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.last_delivery_mile_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.return_flow_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.return_flow_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.additional_fees_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.additional_fees_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.purchases_costs_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.purchases_costs_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.transferts_costs_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.transferts_costs_y_hist) : 'N/A'}</td>
<td className="table-text">{dep.total_budget_year_y_hist ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.total_budget_year_y_hist) : 'N/A'}</td>

          <td className="table-text">{dep.comment_y_hist ?? 'N/A'}</td>
          <td>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>


<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text">Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Product</span>
          <select
            className="form-select"
            value={this.state.productdescription}
            onChange={(event) => this.setState({ productdescription: event.target.value })}
          >
            <option value="">Select a product</option>
            {this.state.productdescriptions.map((product) => (
              <option key={product} value={product}>
                {product}
              </option>
            ))}
          </select>
        </div>


      </div>
    </div>
  </div>
</div>
</div>
  )
}
  }




